<template>
  <aside class="sidebar">
    <div class="sidebar__part">
      <div class="sidebar__heading">
        <p class="heading heading_size_h3">Примеры запросов</p>
        <p class="body body_size_M">Нажми на запрос, чтобы отправить его в чат</p>
      </div>

      <div class="sidebar__prompts" :class="{ 'disabled' : rest === 0 }">
        <kaz-action
          v-for="(prompt, index) in randomPrompts"
          :key="index"
          :title="prompt.heading"
          :description="prompt.text"
          @click="sendPromptToChat(prompt.textForSend)"
        />
      </div>
    </div>
    <div class="sidebar__part">
      <div class="user__main">
        <limits-container
          v-if="limitReady"
          :rest="rest" 
          :limit="limit"
        />
        <SkeletonLoader
          v-else
          width="100px" 
          height="32px"
          borderRadius="30px"
        />
        <div class="user__actions">
          <template v-if="sessionActive" >
            <div 
              class="user__info user__info_desktop"
              @click="this.$router.push({ name: 'personal-info' })"
            >
              <kaz-avatar :size="'S'" :avatarImage="getSrcAvatar" />
              <p class="body body_size_M">
                {{ getUserData.firstName }} {{ getUserData.lastName }}
              </p>
            </div>
            <KazDropdown
              ref="user_menu" 
              :positionX="windowWidth > 992 ? 'left' : 'right'" 
              :positionY="windowWidth > 992 ? 'bottom' : 'top'"
            >
              <template v-slot:button>
                <kaz-button
                  label=""
                  size="M"
                  appearance="secondary"
                  mode="onLight"
                  :leftIcon="true"
                  leftIconName="kuiIconMenuLarge"
                />
              </template>
              <template v-slot:menu>
                <ul class="user__menu">
                  <li
                    class="user__info user__info_mobile"
                    @click="this.$router.push({ name: 'personal-info' })"
                  >
                    <kaz-avatar :size="'S'" :avatarImage="getSrcAvatar" />
                    <p class="body body_size_M">
                      {{ getUserData.firstName }} {{ getUserData.lastName }}
                    </p>
                  </li>
                  <li>
                    <kaz-button
                      class="user__info_mobile"
                      title="Вернуться на главную"
                      label="Вернуться на главную"
                      size="M"
                      appearance="flat"
                      :leftIcon="true"
                      leftIconName="kuiIconChevronLeftLarge"
                      @click="$router.push({name: 'tasks'})"
                    />
                  </li>
                  <li>
                    <kaz-button
                      title="Очистить текущий чат"
                      label="Очистить текущий чат"
                      size="M"
                      appearance="flat"
                      :leftIcon="true"
                      leftIconName="kuiIconTrashLarge"
                      @click="clearChat"
                    />
                  </li>
                </ul>
              </template>
            </KazDropdown>
          </template>
        </div>
      </div>
      <KazButton
        label="Купить больше запросов"
        :centerContent="true"
        @click="$router.push({ name: 'subscriptions' })"
      />
      <kaz-button
        v-if="!sessionActive"
        class="user__login"
        label="Войти в аккаунт"
        mode="normal"
        appearance="outline"
        :leftIcon="false"
        leftIconName="kuiIconAlertCircleLarge"
        :rightIcon="true"
        rightIconName="kuiIconLoginLarge"
        :centerContent="true"
        size="L"
        @click="this.$router.push({ name: 'login' })"
      />
      <KazButton
        class="user__info_desktop"
        label="Вернуться на главную"
        appearance="flat"
        size="L"
        :centerContent="true"
        @click="$router.push({ name: 'tasks' })"
      />
    </div>
  </aside>
</template>


<script>
import { mapGetters } from 'vuex';

import CardBackground from '@/components/UI/card/CardBackground.vue';
import KazAction from '@/components/KazUI/atoms/action';
import KazBadge from '@/components/KazUI/atoms/badge'
import KazAvatar from '@/components/KazUI/atoms/avatar'
import KazDropdown from '@/components/KazUI/slots/dropdown'
import KazButton from '@/components/KazUI/atoms/button'
import SkeletonLoader from '@/components/KazUI/skeleton';

import LimitsContainer from './LimitsContainer.vue'

import useLoadingStates from '@/hooks/loading/useLoadingStates.js';
import useSubscriptions from '@/hooks/billing/useSubscriptions.js';

import prompts from '../prompts.js';


export default {
  name: 'sidebar',

  components: {
    CardBackground,
    KazAction,
    KazBadge,
    KazAvatar,
    KazDropdown,
    KazButton,
    LimitsContainer,
    SkeletonLoader,
  },

  props: {
    limitReady: {
      type: Boolean,
      default: false
    },
    limitExceeded: {
      type: Boolean,
      default: false
    },
    rest: {
      type: Number,
      default: 2
    },
    limit: {
      type: Number,
      default: 2
    }
  },

  emits: ['clear-chat', 'send-prompt-to-chat'],

  setup() {
    const { LOADING_STATES } = useLoadingStates();
    const { activeSubscriptions, initSubsInfo } = useSubscriptions();
    return { LOADING_STATES, activeSubscriptions, initSubsInfo }
  },

  data() {
    return{
      prompts: prompts,
      // limitExceeded: false,
      initState: this.LOADING_STATES.INIT,
      windowWidth: 0,
    }
  },


  computed: {
    ...mapGetters({
      getStudent: 'userData/getStudent',
      getUserData: 'userData/getUserData',
      getSrcAvatar: 'userData/getSrcAvatar',
      sessionActive: 'authData/sessionActive',
    }),
    randomPrompts() {
      const shuffledPrompts = this.prompts.sort(() => 0.5 - Math.random());
      return shuffledPrompts.slice(0, 6);
    },
    isInitialized() {
      return this.initState === this.LOADING_STATES.LOADED
    }
  },

  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    toggleSideBar(){
      if (this.windowWidth <= 992){
        this.isMobileSideBarClosed = !this.isMobileSideBarClosed
      } else {
        this.isSideBarClosed = !this.isSideBarClosed;
      }
    },
    hideAutoSendPrompts() {
      const autoSendPrompts = this.$refs.sidebar;
      if (autoSendPrompts) {
        autoSendPrompts.style.opacity = '.5';
        autoSendPrompts.style.transition = '.3s ease-in-out';
      }
    },
    showAutoSendPrompts() {
      const autoSendPrompts = this.$refs.sidebar;
      if (autoSendPrompts) {
        autoSendPrompts.style.opacity = '1';
        autoSendPrompts.style.transition = '.3s ease-in-out';
      }
    },
    clearChat() {
      this.$emit('clear-chat');
      this.$refs.user_menu.hideMenu();
    },
    sendPromptToChat(promptText) {
      this.$emit('send-prompt-to-chat', promptText);
    },
  },

  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },

  created() {
    if(this.windowWidth <= 992){
      return this.isSideBarClosed = true
    }
  }
};
</script>

<style scoped>
.sidebar{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 340px;
  padding: 16px;
  background-color: var(--kaz-base-base-01);
  box-shadow: var(--kaz-shadow-default);
}

.sidebar__part{
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sidebar__part:first-of-type{
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sidebar__part:last-of-type{
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sidebar__heading{
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar__prompts{
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.user__actions{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.user__info{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 4px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: var(--kaz-transition-molecules);
}

.user__info:hover{
  background-color: var(--kaz-base-secondary-hover);
  transition: var(--kaz-transition-molecules);
}

.user__info_mobile {
  display: none;
}

.disabled{
  pointer-events: none;
  opacity: 0.5;
}

.user__menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.user__menu button {
  width: 100%;
}

.user__main {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.user__main > *:first-child {
  align-self: flex-end;
}

.user__login {
  flex: 1;
}

@media screen and (max-width: 992px) {
  .sidebar{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: fit-content;
    width: 100%;
    max-width: 100%;
    background-color: var(--kaz-base-base-01);
    box-shadow: var(--kaz-shadow-default);
  }
  .sidebar__part:first-of-type{
    display: none;
  }
  .user__actions{
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  .user__info_desktop {
    display: none; 
  }
  .user__info_mobile {
    display: flex;
  }
  .user__main {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .user__main > *:first-child {
    align-self: initial;
  }
}
</style>